import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=d6f6925e&scoped=true&"
import script from "./MenuSelect.vue?vue&type=script&lang=js&"
export * from "./MenuSelect.vue?vue&type=script&lang=js&"
import style0 from "./MenuSelect.vue?vue&type=style&index=0&id=d6f6925e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f6925e",
  null
  
)

export default component.exports